/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Update_Version_TitleInputs */

const en_dialog_update_version_title = /** @type {(inputs: Dialog_Update_Version_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Required`)
};

const ar_dialog_update_version_title = /** @type {(inputs: Dialog_Update_Version_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التحديث مطلوب`)
};

const de_dialog_update_version_title = /** @type {(inputs: Dialog_Update_Version_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update erforderlich`)
};

const es_dialog_update_version_title = /** @type {(inputs: Dialog_Update_Version_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualización requerida`)
};

const fr_dialog_update_version_title = /** @type {(inputs: Dialog_Update_Version_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise à jour requise`)
};

const it_dialog_update_version_title = /** @type {(inputs: Dialog_Update_Version_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornamento richiesto`)
};

const ja_dialog_update_version_title = /** @type {(inputs: Dialog_Update_Version_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アップデートが必要です`)
};

const ko_dialog_update_version_title = /** @type {(inputs: Dialog_Update_Version_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`업데이트 필요`)
};

const pt_br_dialog_update_version_title = /** @type {(inputs: Dialog_Update_Version_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualização necessária`)
};

const ru_dialog_update_version_title = /** @type {(inputs: Dialog_Update_Version_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Требуется обновление`)
};

const th_dialog_update_version_title = /** @type {(inputs: Dialog_Update_Version_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ต้องอัปเดต`)
};

const tr_dialog_update_version_title = /** @type {(inputs: Dialog_Update_Version_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Güncelleme gerekli`)
};

const zh_cn_dialog_update_version_title = /** @type {(inputs: Dialog_Update_Version_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请更新版本`)
};

const zh_tw_dialog_update_version_title = /** @type {(inputs: Dialog_Update_Version_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請更新版本`)
};

/**
* | output |
* | --- |
* | "Update Required" |
*
* @param {Dialog_Update_Version_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_update_version_title = /** @type {((inputs?: Dialog_Update_Version_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Update_Version_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_update_version_title(inputs)
	if (locale === "ar") return ar_dialog_update_version_title(inputs)
	if (locale === "de") return de_dialog_update_version_title(inputs)
	if (locale === "es") return es_dialog_update_version_title(inputs)
	if (locale === "fr") return fr_dialog_update_version_title(inputs)
	if (locale === "it") return it_dialog_update_version_title(inputs)
	if (locale === "ja") return ja_dialog_update_version_title(inputs)
	if (locale === "ko") return ko_dialog_update_version_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_update_version_title(inputs)
	if (locale === "ru") return ru_dialog_update_version_title(inputs)
	if (locale === "th") return th_dialog_update_version_title(inputs)
	if (locale === "tr") return tr_dialog_update_version_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_update_version_title(inputs)
	return zh_tw_dialog_update_version_title(inputs)
});